import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const ViewToggleButton = ({ active, onClick, icon, label }) => (
  <button
    type      = "button"
    onClick   = {onClick}
    className = {`inline-flex items-center gap-2 h-9 px-3 rounded-md text-[13px] font-medium transition ${
      active
        ? "bg-brand-500 text-white"
        : "bg-white text-slate-600 hover:text-slate-900"
    }`}
  >
    <FontAwesomeIcon icon={icon} className="text-[12px]" />
    {label}
  </button>
)

const Header = ({ count, viewMode, onViewChange }) => (
  <div className="flex items-start justify-between gap-6 mb-6">
    <div className="flex items-baseline gap-3">
      <h1 className="text-2xl font-semibold text-slate-900">
        {I18n.t("projects.index.title")}
      </h1>
      <span className="text-sm text-slate-500">
        {I18n.t("projects.index.count", { count })}
      </span>
    </div>

    <div className="inline-flex items-center bg-white rounded-md border border-slate-200 p-1 gap-1">
      <ViewToggleButton
        active  = {viewMode === "list"}
        onClick = {() => onViewChange("list")}
        icon    = "list"
        label   = {I18n.t("projects.index.view.list")}
      />
      <ViewToggleButton
        active  = {viewMode === "timeline"}
        onClick = {() => onViewChange("timeline")}
        icon    = "calendar-week"
        label   = {I18n.t("projects.index.view.timeline")}
      />
    </div>
  </div>
)

export default Header
